import React, { FC, memo, useState, useEffect } from 'react';
import { createUseStyles, userInfo } from 'core/src';
import { View } from 'react-native';
import {
  Avatar,
  Button,
  MyTextInput,
  ScrollingView,
  Spacing,
  Typography,
} from 'components/src';
import Ionicons from 'react-native-vector-icons/Ionicons';
import {
  Store,
  showBottomSheetUpdate,
} from '../../organisms/myBottomsheet/store';
import { SocketIOContext } from '../../app/appcontainer';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import { useTranslation } from 'react-i18next';

const MaterialIconsX = MaterialIcons as unknown as React.ComponentType<any>;
const IoniconsX = Ionicons as unknown as React.ComponentType<any>;

interface User {
  id: any;
  participants: any;
}
interface SelectedItem {
  id: any;
  type: string;
}

interface ListProps {
  messages: any;
  message: any;
  setSelectedItemX?: any;
  setSelect?: any;
}

const ForwardList: FC<ListProps> = memo(
  ({ messages, message, setSelectedItemX, setSelect }) => {
    const { userName } = userInfo();
    const { styles, colors } = useStyles();
    const [selectedItems, setSelectedItems] = useState<SelectedItem[]>([]);
    const [conversationList, setConversationList] = useState([]);

    const dispatch = Store.useDispatch();
    const [filterUser, setFilterUser] = useState<any>('');
    const { i18n } = useTranslation();

    useEffect(() => {
      SocketIOContext?.invoke('forwardMessageConversations', {
        pageSize: '150',
        pageNumber: '1',
      });
    }, []);

    SocketIOContext.useSocketEffect<any, any>(
      'forwardMessageConversations',
      (event: any): any => {
        console.log({ event });
        setConversationList(event?.conversations);
      },
      [],
    );

    // const { mutate } = usePostChatForwardMessage({
    //   onSuccess: () => {
    //     dispatch(showBottomSheetUpdate(false));
    //   },
    // });
    const sendMessage = () => {
      SocketIOContext?.invoke('forwardMessage', {
        toConversationIds: selectedItems,
        messageIds: messages?.length > 0 ? messages : message,
      });
      dispatch(showBottomSheetUpdate(false));
      setSelectedItemX([]);
      setSelect(false);
    };

    const handleItemClick = (id: any) => {
      const index = selectedItems.indexOf(id);

      if (index !== -1) {
        setSelectedItems((prevList) => prevList?.filter((item) => item !== id));
      } else {
        setSelectedItems((prevList) => [...prevList, id]);
      }
    };

    const accessToContacts = conversationList?.filter((item: any) => {
      return item.checkAccess === true;
    });

    const filteredData = accessToContacts?.filter((item: User) =>
      item.participants.some(
        (participant: any) => participant.user.user_name !== userName,
      ),
    );

    //////////////////////////////////////////////////////////////
    const channels = filteredData?.filter((item: any) => {
      return item.type === 'channel';
    });
    const filterChannel = channels?.filter((item: any) => {
      return item.admins.map((i: any) => {
        return i.userName?.includes(userName);
      });
    });

    const _filteredData = filteredData?.filter((item: any) => {
      //@ts-ignore
      return !filterChannel?.includes(item);
    });

    const newData = _filteredData?.filter((item: any) => {
      return (
        item?.title?.includes(filterUser) ||
        item.participants
          ?.find((participant: any) => participant?.user.user_name !== userName)
          .user.name_and_family?.includes(filterUser)
      );
    });

    return (
      <>
        <View style={{ height: 500, width: '100%' }}>
          <MyTextInput
            inputWidth={'100%'}
            change={(text) => {
              setFilterUser(text);
            }}
            classes={styles.input}
            inlineImageLeft={
              <MaterialIconsX
                name="search"
                size={25}
                color={colors.secondryColor}
              />
            }
            placeholder={i18n.t('enterName') + '...'}
          />
          <ScrollingView>
            <View style={styles.main}>
              {_filteredData && _filteredData.length > 0 ? (
                newData.map((item: any, index: number) => {
                  const ownerChat =
                    item.title ||
                    item.participants?.find(
                      (participant: any) =>
                        participant?.user.user_name !== userName,
                    ).user.name_and_family;

                  const ShowName = ownerChat
                    ? ownerChat.length > 25
                      ? ownerChat.substring(0, 23) + '...'
                      : ownerChat
                    : '';

                  return (
                    <View
                      key={item.id}
                      style={[
                        styles.container,
                        {
                          opacity: selectedItems?.includes(item?.id) ? 0.3 : 1,
                        },
                      ]}
                    >
                      <Button
                        flexDirection={'column'}
                        onClick={() => handleItemClick(item?.id)}
                      >
                        <Avatar
                          openImage={false}
                          radius={80}
                          size={70}
                          source={
                            item.type === 'privateChat'
                              ? item.participants?.find(
                                  (participant: any) =>
                                    participant?.user.user_name !== userName,
                                ).user.avatar
                              : ''
                          }
                        />
                        <Spacing vertical={10} />
                        <View
                          style={{
                            justifyContent: 'center',
                            flexDirection: 'row',
                          }}
                        >
                          <Typography
                            classes={{ flexWrap: 'wrap', width: 70 }}
                            text={ShowName}
                            color={colors.primaryColor}
                            weight={'bold'}
                            textAlign={'center'}
                          />
                          <Spacing vertical={3} />
                        </View>
                      </Button>
                    </View>
                  );
                })
              ) : (
                <Typography text="No data available" />
              )}
            </View>
          </ScrollingView>
        </View>
        <View
          style={{
            flex: 1,
            flexDirection: 'row',
            alignContent: 'center',
            justifyContent: 'center',
            height: 100,
            bottom: -30,
            right: 20,
            position: 'absolute',
          }}
        >
          <Button classes={styles.button} onClick={sendMessage}>
            <IoniconsX name={'send'} size={25} color={'#fff'} />
          </Button>
        </View>
      </>
    );
  },
);

const useStyles = createUseStyles(({ colors, theme }) => ({
  container: {
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    width: 85,
    marginBottom: 10,
  },
  text: {
    textAlign: 'center',
  },
  main: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: 15,
  },
  button: {
    backgroundColor: colors.color03,
    padding: 12,
    borderRadius: 40,
    width: 50,
    height: 50,
    textAlign: 'center',
    alignItems: 'center',
  },
  input: {
    backgroundColor: colors.container,
  },
}));

export { ForwardList };
